import { SignalTestResultState, SignalTestRowState } from "../types";

import { SIGNAL_COMPACT_REQUEST_ROW_HEIGHT_REM, SIGNAL_SKELETON_ROW_KEYS } from "./constants";
import SampleRequestRow from "./SampleRequestRow";

import { Skeleton } from "@/components/ui/skeleton";
import { SignalSampleRequestLog } from "@/queries/signals";

interface RequestLogsContentProps {
  isLoading: boolean;
  requestLogs: SignalSampleRequestLog[];
  workspaceId: number;
  testStates: Record<number, SignalTestRowState>;
  isTestingAll: boolean;
  hasAssertion: boolean;
  onRemoveRequest: (requestLogId: number) => void;
  onTestRequest: (requestLogId: number) => void;
}

const RequestLogsContent = ({
  isLoading,
  requestLogs,
  workspaceId,
  testStates,
  isTestingAll,
  hasAssertion,
  onRemoveRequest,
  onTestRequest,
}: RequestLogsContentProps) => {
  if (isLoading) {
    return (
      <div className="divide-y divide-gray-200">
        {SIGNAL_SKELETON_ROW_KEYS.map(key => (
          <div
            key={key}
            className="px-5 py-4"
            style={{ minHeight: `${SIGNAL_COMPACT_REQUEST_ROW_HEIGHT_REM}rem` }}
          >
            <Skeleton className="h-full min-h-[4.5rem] w-full" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200">
      {requestLogs.map(requestLog => {
        const testState = testStates[requestLog.id];
        return (
          <SampleRequestRow
            key={requestLog.id}
            requestLog={requestLog}
            workspaceId={workspaceId}
            testResult={testState?.result ?? SignalTestResultState.IDLE}
            testDetails={testState?.details}
            errorMessage={testState?.errorMessage}
            isTesting={testState?.result === SignalTestResultState.LOADING || isTestingAll}
            canTest={hasAssertion}
            onRemove={() => onRemoveRequest(requestLog.id)}
            onTest={() => onTestRequest(requestLog.id)}
          />
        );
      })}
    </div>
  );
};

export default RequestLogsContent;
